import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SNModalService } from '@web-services/modal/snModal.service';
import { SNModal } from '@web-services/modal/snModal.interfaces';

@Component({
	selector: 'delete-item-modal',
	template: require('./delete-item-modal.html'),
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteItemModalComponent implements SNModal {
	@Input() modalTitle: string;
	@Input() modalData: any;
	@Input() itemName: string;
	@Input() btnDisabled: boolean;

	constructor(
		public activeModal: NgbActiveModal,
		private modalService: SNModalService
	) {}

	onSubmit(): void {
		this.modalService.setModalData(this.modalData);
	}

	onDismiss(): void {
		this.activeModal.dismiss();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/settings/common/delete-item-modal/delete-item-modal.ts